module.exports = __webpack_public_path__ + "static/studies-1153932360.7062326f.jpg";